import React, { useCallback, useState } from 'react';
import clsx from 'clsx';

import { CalendarPanelValue } from './types';
import { TILE_HEIGHT, TILE_WIDTH } from './constants';
import * as styles from './calendar-panel-cell.scss';

export interface CalendarPanelCellProps {
  dayNum: number;
  value?: CalendarPanelValue;
}

export const CalendarPanelCell = ({ dayNum, value }: CalendarPanelCellProps) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const handleMouseEnter = useCallback(() => {
    setShowTooltip(true);
  }, []);

  const handleMouseLeave = useCallback(() => {
    setShowTooltip(false);
  }, []);

  return (
    <li
      className={clsx(styles.tile, styles.contentTile)}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={{ height: TILE_HEIGHT, width: TILE_WIDTH }}
    >
      <span className={styles.tileDay}>{dayNum}</span>
      <span className={styles.tileValue}>{value?.value || ''}</span>
      {value?.highlight && <span className={styles.tileHighlight} />}
      {value?.title && (
        <span className={clsx(styles.tooltip, { [styles.hidden]: !showTooltip })} aria-hidden="true">
          <span className={styles.triangle} />
          {value.title}
        </span>
      )}
    </li>
  );
};
